/**
 * combines the arguments in reverse order.
 * If there is only one object candidate returns it directly.
 * otherwise blends all candidates preferring the ones first.
 *
 * @param args {array}
 *
 * @returns {object}
 */
export default function blend(...args) {
  const base = args.reverse().filter(a => a && typeof a === 'object');
  if (base.length === 1) return base[0];
  if (base.length === 0) return {};

  return base.reduce((memo, candidate) => ({ ...memo, ...candidate }));
}



// WEBPACK FOOTER //
// ./src/components/blend.js